import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { cellValuePdf, RowExportTypePdf } from "types"
import { APPROVAL, convertNumber } from "utils"
import { ApproveType } from "../../types"

type UseExportPdf = {
  data: ApproveType[]
}

export const useExportPdf = ({ data }: UseExportPdf) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "DATE", key: "date", width: 15 },
    { header: "LOCATION", key: "location", width: 25 },
    { header: "ITEM", key: "item", width: 15 },
    { header: "DESCRIPTION", key: "description", width: 15 },
    { header: "STOCK", key: "stock", width: 15 },
    { header: "UNIT", key: "unit", width: 15 },
    { header: "STATUS", key: "status", width: 15 },
    { header: "DATE APPROVE", key: "da", width: 15 }
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      location: item.location_name,
      item: item.product_barcode,
      description: item.product_name,
      stock: numberFormat(Number(item.soh)),
      unit: item.unit_name,
      status: APPROVAL[item.approve_status],
      da: item.approve_date ?? ""
    }
  })

  return {
    handleExportPdf: () =>
      pdf(<PdfTemplate data={dataMap} column={columns} />)
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `approval-opening-stock.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>APPROVAL OPENING STOCK</Text>
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}
        />
      </Page>
    </Document>
  )
}
